import type {ReactElement} from 'react';
import type {CheckoutFlowContentProps} from '@Components/checkout-flow/components/checkout-flow-content/checkout-flow-content.types';
import {CheckoutStep} from '@Components/checkout-flow/checkout-flow.types';
import {assertNever} from '@Utils/assert-never.util';
import {EmailRequiredStep} from '@Components/checkout-flow/components/email-required-step/email-required-step';
import {CreditPacksStep} from '@Components/checkout-flow/components/credit-packs-step/credit-packs-step';
import {PaymentOptionsStep} from '@Components/checkout-flow/components/payment-options-step/payment-options-step';
import {BillingAddressListStep} from '@Components/checkout-flow/components/billing-address-list-step/billing-address-list-step';
import {BillingAddressFormStep} from '@Components/checkout-flow/components/billing-address-form-step/billing-address-form-step';
import {StripeEmbeddedStep} from '@Components/checkout-flow/components/stripe-embedded-step/stripe-embedded-step';
import {FinalizingStep} from '@Components/checkout-flow/components/finalizing-step/finalizing-step';
import {PremiumConfirmationStep} from '@Components/checkout-flow/components/premium-confirmation-step/premium-confirmation-step';
import {CheckoutErrorStep} from '@Components/checkout-flow/components/checkout-error-step/checkout-error-step';

export function CheckoutFlowContent({flow}: CheckoutFlowContentProps): ReactElement | null {
  const {request, controller, step} = flow;
  if (request === null) {
    return null;
  }

  switch (step) {
    case CheckoutStep.PREFLIGHT:
      return null;
    case CheckoutStep.EMAIL_REQUIRED:
      return <EmailRequiredStep request={request} controller={controller} />;
    case CheckoutStep.CREDIT_PACKS:
      return <CreditPacksStep request={request} controller={controller} />;
    case CheckoutStep.PAYMENT_OPTIONS:
      return <PaymentOptionsStep request={request} controller={controller} />;
    case CheckoutStep.BILLING_ADDRESS_LIST:
      return <BillingAddressListStep request={request} controller={controller} />;
    case CheckoutStep.BILLING_ADDRESS_FORM:
      return <BillingAddressFormStep request={request} controller={controller} />;
    case CheckoutStep.STRIPE_EMBEDDED:
      return <StripeEmbeddedStep request={request} controller={controller} />;
    case CheckoutStep.FINALIZING:
      return <FinalizingStep request={request} controller={controller} />;
    case CheckoutStep.PREMIUM_CONFIRMATION:
      return <PremiumConfirmationStep request={request} controller={controller} />;
    case CheckoutStep.ERROR:
      return <CheckoutErrorStep request={request} controller={controller} />;
    default:
      return assertNever(step);
  }
}
